const env = {
  authMode: (import.meta.env.VITE_AUTH_MODE || 'dev') as 'dev' | 'demo' | 'cognito',
  apiUrl: import.meta.env.VITE_API_URL || '/api/v1',
  cognitoUserPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID || '',
  cognitoClientId: import.meta.env.VITE_COGNITO_CLIENT_ID || '',
  cognitoDomain: import.meta.env.VITE_COGNITO_DOMAIN || '',
  cognitoRedirectSignIn: import.meta.env.VITE_COGNITO_REDIRECT_SIGNIN || 'http://localhost:3000/',
  cognitoRedirectSignOut: import.meta.env.VITE_COGNITO_REDIRECT_SIGNOUT || 'http://localhost:3000/',
  // Set by the deploy workflow; empty for local builds.
  isStage: import.meta.env.VITE_DEPLOY_ENV === 'staging',
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,
} as const;

export default env;
